import React, { Component } from 'react';
import toastr, { success } from 'toastr';
import objectToFormdata from 'object-to-formdata';
import Loadable from 'react-loading-overlay';
import urlParse from 'url-parse';
import reactWindowSize from 'react-window-size';
import 'video-react/dist/video-react.css';
import apiClient from '../util/api-client';
import ListFileErrors from './ListFileError';
import { reload as reloadActivities } from './ActivitiesButton';
import { Progress } from 'reactstrap';
import axios from 'axios';
import UploadSection from './UploadSection';
import FileTable from './FileTable';
import { ALLOWED_FILE_TYPES } from '../util/common';
import * as MultipartUpload from '../util/multipart-upload';


const url = new URL(location.href);

const ONE_GB_TO_BYTES = Math.pow(2,30);
const PLANS = ['free', 'minimum', 'basic', 'master']
const PLANS_TEXT = ['無料','ミニマム','ベーシック','マスター']
const REGEXP_URL = /projects\/(\d+)\/(\d+)\/akaire\/(\S)/
const TICKET_REGEXP_URL = /projects\/(\d+)\/(\d+)\/(\d+)\/akaire\/(\S)/
const MAX_FILES = 30;
const csrfTokenTag = document.querySelector('meta[name="csrf-token"]');

class NewMultipleAkaireFiles extends Component {
  constructor(props) {
    super(props);
    const { id, baseURL, last_page_id, is_create_video_embed, is_create_pass_video, current_total_size } = props;
    this.props = { ...this.props, ...props };
    this.state = {
      isDisableUpload: true,
      files: [],
      numberShowFile: 10,
      fileErrors: [],
      fileUploadErrors: [],
      fileUploadSuccess: [],
      user: {},
      project: {},
      loadingText: null,
      percentComplete: 0,
      animations: [],
      markers: [],
      pages: [],
      currentAnimationId: null,
      currentPageId: last_page_id,
      assignments: [],
      shouldShowGetUrlModal: false,
      shouldShowProjectShareModal: false,
      shouldShowProjectFormModal: false,
      shouldShowAnimationUploaderModal: false,
      shouldShowAnimationUploaderImageModal: false,
      shouldShowCompletionModal: false,
      shouldShowPublicUrlModal: false,
      shouldShowGetUrlYoutube: false,
      isLoading: false,
      activeTab: 'markers',
      timerCheckAnimation: null,
      responseConvertVideo: null,
      timerDownloadExtensionFile: null,
      downloadExtensionUrl: null,
      convertFile: false,
      completed: 0,
      finishConvert: false,
      changeCss: false,
      uploadedDataInfo: {},
      isNewAnimationCreated: false,
      membersInComment: [],
      animationSelectCurrent: null,
      is_create_video_embed: is_create_video_embed,
      is_capture_video_youtube: false,
      is_cancel_capture_video_youtube: false,
      isShowFullscreenAnimation: false,
      is_create_pass_video: is_create_pass_video,
      isShowInputPassVideo: false,
      passwordShareVideo: '',
      isDisabledButtonSavePass: true,
      isShowInputDemo: false,
      currentPasswordShareVideo: '',
      currentTotalSize: current_total_size,
      showProgressBar: false,
      convert_file: false,
      nameLastFile: '',
    };
    this.currentURL = baseURL;
    this.baseURL = baseURL
    this.apiClient = apiClient({ baseURL: this.baseURL });
    this.apiClientGetLink = axios.create({
      headers: {
        'X-CSRF-TOKEN': csrfTokenTag && csrfTokenTag.getAttribute('content') || '',
        'Accept': 'application/json'
      },
    });
    this.multipartApiClient = apiClient({ baseURL: '/' });
    this.concurrentUploads = 3;
    this.percentConvert = null;
  }

  componentDidUpdate(_, prev) {
    const { is_cancel_capture_video_youtube, is_capture_video_youtube } = this.state;
    if (is_cancel_capture_video_youtube && is_capture_video_youtube !== prev.is_capture_video_youtube &&
      is_capture_video_youtube === false && prev.is_capture_video_youtube === true) {
      this.setState({is_cancel_capture_video_youtube: false})
    }
  }

  toggleElementList(className, show = true) {
    const elementList = document.getElementsByClassName(className);
    for (let i = 0; i < elementList.length; i ++) {
      elementList[i].style.visibility = show ? "visible" : "hidden";
    }
  }

  currentAnimation = () => this.state.animations.find(_ => _.id === this.state.currentAnimationId)
  fromProjectId = () => {
    return url.searchParams.get('from_project_id');
  }
  fromTaskId = () => {
    return url.searchParams.get('from_task_id');
  }
  fromWorkId = () => {
    return url.searchParams.get('from_work_id');
  }
  fromPageId = () => {
    return url.searchParams.get('from_page_id');
  }
  fromAkaireFileId = () => {
    return url.searchParams.get('from_file_id');
  }
  withNewTask = () => {
    return url.searchParams.get('with_new_task');
  }
  textFor = (plan) => {
    return PLANS.indexOf(plan) >= 0 && PLANS_TEXT[PLANS.indexOf(plan)]
  }
  showAlertLimitVideo = () => {
    const {current_limit_video: currentLimitVideo, current_subscription_type: currentSubscriptionType} = this.props;
    const nextLevelPlan = this.textFor(PLANS[PLANS.indexOf(currentSubscriptionType)+1])
    const text = nextLevelPlan ? `${nextLevelPlan}プラン以上にアップグレードするか、データの圧縮をしてからアップロードをお願い致します。` : ''
    toastr.error(`${this.textFor(currentSubscriptionType)}プランの場合、1回でのアップロード制限は${currentLimitVideo}GB以内です。${text}`);
  }

  convertVideo = async (signedUrl, filename) => {
    const checkUploadNewPage = $('#uploadNewPagePopup').attr('data-upload-new') == 'true'
    const pageId = checkUploadNewPage ? 'new' : $('#uploadVersionPopup').attr('data-page-id')
    const convertPromise = new Promise(async (resolve, reject) => {
      while (true) {
        try {
          const res = await this.apiClient.put(
            `${pageId ? 'animations/convert_mp4' : 'convert_mp4'}`,
            {
              pathname: decodeURI(urlParse(signedUrl).pathname),
              page_id: pageId,
              filename: filename,
              from_project_id: this.fromProjectId() ,
              from_task_id: this.fromTaskId(),
              from_work_id: this.fromWorkId(),
              from_page_id: this.fromPageId(),
              from_akaire_file_id: this.fromAkaireFileId(),
              with_new_task: this.withNewTask(),
            }) // decode the file name to the correct original name
            if (res.data.type === 'success') {
              setTimeout(() => {
                reloadActivities();
              }, 1000);
              resolve(true); // Resolve promise khi convert hoàn thành
              break; // Thoát khỏi vòng lặp
            }
            await new Promise((resolve) => setTimeout(resolve, 2000));
        } catch (error) {
          this.endLoading();
          // this.close('AnimationUploaderModal');
          reject(error);
          break;
        }
      }
    });
    const isDoneConvert = await convertPromise;
    return isDoneConvert;
  }
  file_extension = (filename) => {
    const extensions = filename.split('.').slice(-1)
    if (extensions.length) { return extensions[0].toUpperCase() }
  }

  finalizeAnimation = () => {
    const { currentAnimationId } = this.state;
    this.startLoading('Now processing...');
    return this.apiClient.post(`animations/${currentAnimationId}/finalization`)
      .then(() => {
        toastr.success('完成しました');
        // reloadActivities();
      })
      .catch(() => {
        toastr.error('完成できませんでした');
      })
      .finally(this.endLoading);
  }

  toggle = bool => name => {
    this.setState({ [`shouldShow${name}`]: bool });
    if(!bool) {
      if($('#uploadNewPagePopup').attr('data-upload-new') == 'true') {
        $('#uploadNewPagePopup').modal('show')
      } else {
        $('#uploadVersionPopup').modal('show')
      }
    }
  }
  open = this.toggle(true)
  close = this.toggle(false)

  changeURL = (item, newPage = false, idAkaire = null) => {
    let baseURL = this.props.baseURL;
    if(baseURL && baseURL.match(REGEXP_URL)) {
      let pageId = 'new';
      let versionId = 'new';
      let akareId = 'new';
      this.state.pages.map((e,i) => {
        if (item == e.id) {
          pageId = e.id;

          if (this.state.animations.length > 0 && !newPage) {
            this.state.animations.map((item, index) => {
              if (item.id === this.state.currentAnimationId) {
                versionId = item.id;
              }
            });
          }
        }
      });

      if (idAkaire) {
        akareId = idAkaire;
      }
      if (akareId == 'new' && pageId == 'new' && versionId == 'new') {
        let url = '/projects/' + baseURL.match(REGEXP_URL)[1] + '/' + baseURL.match(REGEXP_URL)[2] + '/akaire/new';
      }
      else {
        let url = '/projects/' + baseURL.match(REGEXP_URL)[1] + '/' + baseURL.match(REGEXP_URL)[2] + '/akaire/'+ akareId + '/' + pageId + '/' + versionId;
      }
      window.history.pushState( "", "", url );
    }
  }

  startLoading = (loadingText, title) => {
    this.fadeInLoader();
    $('.message_overlay').removeClass('d-none')
    this.setLoadingContent(loadingText, title)
    this.setState({ isLoading: true });
  }

  endLoading = () => {
    this.setState({ loadingText: null, isLoading: false });
    $('.preloader').fadeOut();
    clearInterval(this.percentConvert);
    this.percentConvert = null;
  }
  convertFile = (file) => this.setState({ convertFile: file })
  finishConvert = (type) => {
    this.setState({ finishConvert: type })
  }
  onSubmitCompletionModal = () => {
    this.finalizeAnimation().then(this.close.bind(this, 'CompletionModal'));
  }

  reloadAfterUpload = () => {
    const countAllFiles = this.state.files.length
    this.startLoading('次の画面に切替わるまで、お待ちください。', 'アップロード中です。')
    window.location.href =
      Routes.list_temp_file_akaire_feature_akaires_path(
        { upload_all: true, allFiles: countAllFiles }
      )
  }

  setLoadingContent = (message, title = null) => {
    this.setState({
      loadingText: (
        <>
          <div style={{ fontWeight: 'bold' }}><p>{title}</p></div>
          <div><p>{message}</p></div>
        </>
      )
    });
  };

  fadeInLoader = () => {
    const pageId = $('#uploadVersionPopup').attr('data-page-id')
    if(pageId) {
      $('.preloader').fadeIn();
      setInterval(() => {
        $('.preloader').css('opacity', 0.2)
      }, 200);
    }
  }

  changeFocus = () => {
    const {isShowInputDemo} = this.state
    this.setState({isShowInputDemo: !isShowInputDemo});
  }

  changeMultipleFiles = (e) => {
    const listFiles = Array.from(e.target.files)
    this.addFiles(listFiles)
  }

  handelOnDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      this.addFiles(Array.from(e.dataTransfer.files))
      e.dataTransfer.clearData();
    }
  }

  isFileBigSize = (file) => {
    const { limit_upload_video: limitUploadVideo } = this.props;
    if (!!limitUploadVideo) {
      return file.size > limitUploadVideo.size;
    }
  }

  // check file type, allow only video file
  isFileTypeNotAllow = (file) => {
    return !ALLOWED_FILE_TYPES.includes(file.type);
  }

  addFiles = (files) => {
    const listFileErrors = Array.from(this.state.fileErrors)
    let isErrors = false
    const validFiles = files.filter((file) => {
      if (this.isFileBigSize(file) || this.isFileTypeNotAllow(file)) {
        const isPresent = listFileErrors.find((f) => file.name === f.name && f.size === file.size)
        if (!isPresent) listFileErrors.push(file);
        isErrors = true
        return false;
      }
      return true;
    });
    if (isErrors) this.setState({ [`shouldShowGetUrlModal`]: true });
    this.setState({ fileErrors: listFileErrors })


    if (this.state.files.length + validFiles.length > MAX_FILES) {
      Popup.alert(`選択できるファイルは最大 ${MAX_FILES} 個までです`);
      return; // Stop adding files if the limit is reached
    }

    const uniqueFiles = validFiles.filter((newFile) => {
      return !this.state.files.some((existingFile) => existingFile.name === newFile.name && existingFile.size === newFile.size);
    });

    this.setState({files: [...this.state.files, ...uniqueFiles]});
    if (this.state.files.length + uniqueFiles.length > 0) {
      this.setState({isDisableUpload: false});
    }
  };

  handleDeleteFile = (file, index) => {
    const listFiles = Array.from(this.state.files)
    const newListFiles = listFiles.filter((f) => f.name !== file.name && f.size !== file.size)
    this.setState({files: newListFiles});
    if (newListFiles.length === 0) {
      this.setState({isDisableUpload: true});
    }
  };

  handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  handleUploadFiles = async (e) => {
    if (this.state.files.length === 0) {
      Popup.alert('アップロードするファイルを選択してください');
      return
    }
    const files = [...this.state.files];
    const data = {
      files: files,
      dataUpload: {
        checkUploadNewPage: $('#uploadNewPagePopup').attr('data-upload-new') == 'true',
        dataPageId: $('#uploadVersionPopup').attr('data-page-id'),
        projectId: this.fromProjectId(),
        taskId: this.fromTaskId(),
        workId: this.fromWorkId(),
        pageId: this.fromPageId(),
        is_multiple_upload: true,
        csrfTokenTag: csrfTokenTag.getAttribute('content'),
        baseURL: this.baseURL
      }
    }
    // if not support service worker then upload file by normal way (not use service worker)
    this.setState({ isDisableUpload: true });
  if (!!navigator.serviceWorker && navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage({
      type: 'UPLOAD_FILES',
      payload: data
    });
  } else {
    if ('serviceWorker' in navigator && 'SyncManager' in window) {
      navigator.serviceWorker.ready.then(registration => {
        registration.sync.register('sync-upload-files').then(() => {
          console.log('Sync registered');
          navigator.serviceWorker.controller.postMessage({
            type: 'UPLOAD_FILES',
            payload: data
          });
        }).catch(err => {
          console.log('Sync registration failed', err);
        });
      });
    } else {
      this.startLoading(`アップロード中...`);
      const filesUploadErrors = [];
      const fileUploadSuccess = [];
      const uploadPromises = this.state.files.map(async (file) => {
        try {
          await this.handleUploadFileToS3(file);
          fileUploadSuccess.push(file);
        } catch (e) {
          filesUploadErrors.push(file);
        }
      });
      await Promise.all(uploadPromises);
      this.setState({ fileUploadErrors: filesUploadErrors });
      this.setState({ fileUploadSuccess: fileUploadSuccess });
      try {
        await this.sendMailWhenUploadMultipleFiles(filesUploadErrors);
      } catch (e) {
        Popup.alert('アップロードプロセスは成功しましたが、メール送信プロセスでエラーが発生しました');
      }
      this.endLoading();
    }
  }
  this.changeURL(this.state.currentPageId);
  this.reloadAfterUpload();
  }

  sendMailWhenUploadMultipleFiles = async (filesUploadErrors) => {
    const listErrorNames = filesUploadErrors.map((file) => file.name)
    const listFileUploads = this.state.files.map((file) => file.name)
    const data = {
      list_errors: listErrorNames,
      list_uploads: listFileUploads
    }
    await this.apiClientGetLink.post(`send_upload_report_email`, data)
      .then((response) => {
      })
      .catch((error) => {
        throw new Error(error)
      })
  }

  handleUploadFileToS3 = async (file) => {
    const fileName = file.name.replace(/[^\w\d_\-.]+/ig, '');
    const type = file.type
    const onProgressCallback = (progress) => {
      this.onUploadProgress(progress);
    };

    const signedUrl = await MultipartUpload.performMultipartUpload(
      file,
      onProgressCallback,
      this.concurrentUploads,
    );

    const { url } = signedUrl;

    const checkUploadNewPage = $('#uploadNewPagePopup').attr('data-upload-new') == 'true'
    const pageId = checkUploadNewPage ? 'new' : $('#uploadVersionPopup').attr('data-page-id')
    const isConvertFile = type == 'video/x-msvideo' || type == 'video/avi' || type.includes('wmv') || type === 'video/quicktime'
    this.setState({ convert_file: isConvertFile })
    await this.apiClient.post(
      `${pageId ? 'animations' : ''}`,
      {
        pathname: decodeURI(urlParse(url).pathname),
        page_id: pageId,
        filename: fileName,
        from_project_id: this.fromProjectId(),
        from_task_id: this.fromTaskId(),
        from_work_id: this.fromWorkId(),
        from_page_id: this.fromPageId(),
        from_akaire_file_id: this.fromAkaireFileId(),
        with_new_task: this.withNewTask(),
        is_multiple_upload: true
      })
      .then(async(response) => {
        if (isConvertFile) {
          window.time = (((file.size / 1024) * 60000) / (40 * 1024)) + 10000
          const isDoneConvert = await this.convertVideo(url, fileName)
        }
      })
  }

  onUploadProgress = (percent) => {
    this.setState({ showProgressBar: true })
    if(!this.state.convert_file){
      this.setState({ completed: percent })
    }
  }

  showUpload = () => {
    $('#inputFieldFiles').click();
  }

  renderNormal() {
    const { current_user_id: currentUserId, role, id, root_url: rootUrl, statuses,
      is_free_plan: isFreePlan, current_limit_video: currentLimitVideo, token_public_url: token_public_url,
      category, is_akapon_member: isAkaponMember, is_project_owner_member, isAkaponProject, baseURL, limit_upload_video
    } = this.props;
    const {
      files, numberShowFile,
      loadingText, isLoading, shouldShowGetUrlModal, completed, showProgressBar, fileErrors, isDisableUpload
    } = this.state;
    const currentAnimation = this.currentAnimation();
    const token = token_public_url;
    const public_video_token = currentAnimation && currentAnimation.url_token;
    var darkGray = 'l-container u-bg--darkGray py-3 mt-2 mt-sm-0';
    var progressBar = '';
    if (!currentAnimation) {
      darkGray = darkGray.concat(" darkGray-animation")
    }
    if (showProgressBar) {
      progressBar = (
        <Progress value={completed}>{completed}%</Progress>
      )
    }
    const filledData = files.length < numberShowFile ? Array.from({ length: 10 }, (_, index) => files[index]) : files;
    return (
      <div className="animation-inspector">
        <Loadable
          className="loading-overlay"
          active={isLoading}
          zIndex={10000}
        >
          <div className="message_overlay d-none">
            { loadingText }
          </div>
          <div className={darkGray}>
            <div className="l-main">
              <div className="pane-wrapper">
                {/* アニメーション */}
                <div className='create-akaire-box-multiples text-center'>
                  <UploadSection
                    handleOnDrop={this.handelOnDrop}
                    handleDragLeave={this.handleDragLeave}
                    handleDragOver={this.handleDragOver}
                    changeMultipleFiles={this.changeMultipleFiles}
                    showUpload={this.showUpload}
                  />
                  {progressBar}
                  <hr className='text-black' width='100%'size='1px' ></hr>
                  <FileTable
                    files={files}
                    filledData={filledData}
                    handleDeleteFile={this.handleDeleteFile}
                    handleUploadFiles={this.handleUploadFiles}
                    isDisableUpload={isDisableUpload} />
                </div>
              </div>
              {/* / pane-wrapper */}
            </div>
            {/* / l-main */}
          </div>
          {/* / l-container */}


          <ListFileErrors isOpen={shouldShowGetUrlModal} onClickClose={this.close.bind(this, 'GetUrlModal')} token={token}
            rootUrl={rootUrl} files={fileErrors}
            baseURL={this.baseURL} isAkaponProject={isAkaponProject} isCreateOfTemp={true} limitUploadVideo={limit_upload_video}/>
        </Loadable>
      </div>
    )
  }

  render() {
    return this.renderNormal();
  }
}

export default reactWindowSize(NewMultipleAkaireFiles);

export { NewMultipleAkaireFiles };
